import React from 'react';
import {Form} from "react-final-form";
import {FiRefreshCcw} from "react-icons/fi";
import {FilterButton} from "./Button";

const Filter = ({onSubmit, initialValues, formRef, loading, extraButtons = null, children}) => {
    return (
        <div style={{marginBottom: "14px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: "0 8px 8px 8px", padding: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)"}}>
            <Form onSubmit={onSubmit} initialValues={initialValues}
                  render={({values, handleSubmit, form}) => {
                      if (formRef) formRef.current = form;
                      return (
                          <>
                              {typeof children === 'function'
                                  ? children({values, form, submit: handleSubmit})
                                  : children}
                              <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "6px"}}>
                                  {typeof extraButtons === 'function'
                                      ? extraButtons({form, values, submit: handleSubmit})
                                      : extraButtons}
                                  <FilterButton
                                      type="button"
                                      onClick={handleSubmit}
                                      loading={loading}
                                      text="Načíst"
                                      icon={<FiRefreshCcw size={12}/>}
                                  />
                              </div>
                          </>
                      );
                  }}
            />
        </div>
    );
};

export default Filter;
